import { ReactElement } from 'react';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import HomeRepairServiceRoundedIcon from '@mui/icons-material/HomeRepairServiceRounded';

export type SearchType = {
  /** Backstage search document type. Empty string means "all types". */
  value: string;
  /** Human readable label shown on the filter chip. */
  label: string;
  icon: ReactElement;
};

export const searchTypes: SearchType[] = [
  {
    value: '',
    label: 'All',
    icon: <AppsRoundedIcon fontSize="small" />,
  },
  {
    value: 'software-catalog',
    label: 'Catalog',
    icon: <WidgetsRoundedIcon fontSize="small" />,
  },
  {
    value: 'techdocs',
    label: 'TechDocs',
    icon: <MenuBookRoundedIcon fontSize="small" />,
  },
  {
    value: 'academy',
    label: 'Academy',
    icon: <SchoolRoundedIcon fontSize="small" />,
  },
  {
    value: 'tools',
    label: 'Toolbox',
    icon: <HomeRepairServiceRoundedIcon fontSize="small" />,
  },
];
